// ! import all of the widget functions

import menuDisplay from "./utils/menuDisplay";
import { customNavigation } from "../../widgets/custom-navigation/src/widget";
import { sonataDetailedComparisons } from "../../widgets/sonata-detailed-comparisons/src/widget";
import fslightbox from "fslightbox";
import { sonatasTable } from "../../widgets/sonatas-table/src/widget";
import { sonataMetaShare } from "../../widgets/sonata-meta-share/src/widget";
import { sonataLineChart } from "../../widgets/sonata-line-chart/src/widget";
import { sonataVariationTable } from "../../widgets/sonata-variation-table/src/widget";
import { collectionsTable } from "../../widgets/collections-table/src/widget";
import { collectionSonataTable } from "../../widgets/collection-sonata-table/src/widget";
import { collectionKeySignatureChart } from "../../widgets/collection-key-signature-chart/src/widget";
import { collectionToplineMeta } from "../../widgets/collection-topline-meta/src/widget";
import { dataCallToAction } from "../../widgets/data-call-to-action/src/widget";

// ------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() { 

    // Global
    if (IS_PRODUCTION) {
        window.apiUri = 'https://scarlatti-api.curious12.com';
    } else {
        window.apiUri = 'https://scarlatti-api.curious12.com';
        // window.apiUri = 'http://127.0.0.1:8000';
    }
    refreshFsLightbox()
    
    // Widget Scripts
    menuDisplay()
    customNavigation()
    sonataDetailedComparisons()

    // API Functions
    sonatasTable()
    sonataMetaShare()
    sonataLineChart()
    sonataVariationTable()

    collectionsTable()
    collectionToplineMeta()
    collectionKeySignatureChart()
    collectionSonataTable()
    dataCallToAction()

    

});
